module.exports = __webpack_public_path__ + "assets/img/agreement-back.74d689a4.png";